import { AppThunk } from '..';
import { setProperties } from './modal.reducer';
import { IModalReducerProps } from './modal.types';

export const setModalMessage = (properties: IModalReducerProps): AppThunk => {
  return (dispatch) => {
    dispatch(setProperties(properties))
  }
};
